import { AspAgingBucketKey } from 'vopay';
import { useTranslation } from 'react-i18next';

// One label per aging bucket, shared by the summary card's tiles and the
// filter bar's aging select so the two always read the same.
export default function useAgingBucketLabels() {
  const { t } = useTranslation('translations', { keyPrefix: 'Shared.AccountingSystem.AgingOverview' });

  const labels: { [bucket in AspAgingBucketKey]: string } = {
    Current: t('current', { defaultValue: 'Current' }),
    PastDue1To30: t('pastDue1To30', { defaultValue: 'Past due 1–30' }),
    PastDue31To60: t('pastDue31To60', { defaultValue: 'Past due 31–60' }),
    PastDue61To90: t('pastDue61To90', { defaultValue: 'Past due 61–90' }),
    PastDue91Plus: t('pastDue91Plus', { defaultValue: 'Past due 91+' }),
  };

  return labels;
}
